<script setup lang="ts">
import { Search } from 'lucide-vue-next';
import { ref } from 'vue';

import SearchChatSessionsDialog from '@/components/sidebar/SearchChatSessionsDialog.vue';
import { Button } from '@/components/ui/button';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger
} from '@/components/ui/tooltip';

defineProps<{
    isSidebarOpen: boolean;
}>();

const isSearchDialogOpen = ref(false);
</script>

<template>
    <Tooltip :disabled="isSidebarOpen">
        <TooltipTrigger as-child>
            <Button
                size="sm"
                variant="ghost"
                class="flex items-center gap-1 rounded-lg transition-background duration-0 text-muted-foreground hover:text-foreground hover:bg-primary10"
                :class="
                    isSidebarOpen
                        ? 'pl-2 pr-3 justify-start'
                        : 'p-0 w-full bg-transparent text-foreground shadow-none hover:bg-transparent'
                "
                @click="isSearchDialogOpen = true"
            >
                <Search
                    :class="
                        isSidebarOpen ? 'w-4 h-4' : 'w-[1.35rem] h-[1.35rem]'
                    "
                />
                <p class="whitespace-nowrap" v-if="isSidebarOpen">
                    Search chats
                </p>
            </Button>
        </TooltipTrigger>
        <TooltipContent side="right">
            <p>Search chats</p>
        </TooltipContent>
    </Tooltip>

    <SearchChatSessionsDialog v-model:open="isSearchDialogOpen" />
</template>
